import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const proformaExportRoute: InvariantJiraRoute = {
	name: 'proforma-export',
	path: '/jira/forms/export',
	exact: true,
};
